import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store.model';
import { getRightUserUtilSelector } from '../../rights/selectors';
import { getMyWorkspaceSelector } from '../../stoerkID/selectors/StoerkId.selectors';
import { hasPermissionForApp } from '../applicationPermissions';

export function getFeatureToggle(state: RootState) {
  return state.featureToggle;
}

const getApplicationsListFeatureToggle = (state: RootState) =>
  getFeatureToggle(state).applicationsList;

const getApplicationFeatureToggle = (state: RootState) =>
  getFeatureToggle(state).applicationDefault ?? 'devicemanager';

export const getApplicationsFeatureToggle = createSelector(
  [getApplicationsListFeatureToggle],
  (applicationsListString) =>
    applicationsListString?.split(',') ?? ['devicemanager']
);

/**
 * Get applications list filtered by user permissions
 * Only returns apps the user has rights to access
 */
export const getApplicationsWithPermissionsFeatureToggle = createSelector(
  [
    getApplicationsFeatureToggle,
    getRightUserUtilSelector,
    getMyWorkspaceSelector,
  ],
  (applicationsList, rightUserUtil, myWorkspace) => {
    return applicationsList.filter((appId) =>
      hasPermissionForApp(appId, rightUserUtil, myWorkspace?.id ?? '')
    );
  }
);

export const getDefaultApplicationFeatureToggle = createSelector(
  [getApplicationFeatureToggle, getApplicationsFeatureToggle],
  (defaultApplication, applicationsList) => {
    const isDefaultApplicationInList =
      applicationsList.includes(defaultApplication);
    if (isDefaultApplicationInList) {
      return defaultApplication;
    }
    return 'devicemanager';
  }
);
